export const ADD_SENT_SENTRY_ERROR_TYPE = 'ADD_SENT_SENTRY_ERROR_TYPE';

export const addSentSentryErrorTypeAction = payload => ({
  type: ADD_SENT_SENTRY_ERROR_TYPE,
  payload
});
